import { render, staticRenderFns } from "./VirtualCareIndex.vue?vue&type=template&id=0e2d400b&"
import script from "./VirtualCareIndex.vue?vue&type=script&lang=js&"
export * from "./VirtualCareIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports